import { useState } from 'react';
import { mockFaqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20 scroll-mt-20">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs md:text-sm font-medium text-secondary-700 tracking-widest mb-2">FAQ / 常见问题</p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              关于网报吃瓜，你可能想问
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              从内容来源到热度计算，我们把大家问得最多的问题整理在这里。还有疑问，可以在关于我们页面找到联系方式。
            </p>
          </div>

          <div className="lg:col-span-8">
            <dl className="divide-y divide-background-300/60 border-t border-b border-background-300/60">
              {mockFaqs.map((faq, index) => {
                const open = openIndex === index;
                return (
                  <div key={faq.q} className="py-4 md:py-5">
                    <dt>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(open ? null : index)}
                        aria-expanded={open}
                        className="w-full flex items-start justify-between gap-4 text-left cursor-pointer"
                      >
                        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{faq.q}</h3>
                        <span className={`mt-0.5 w-6 h-6 shrink-0 flex items-center justify-center rounded-full ${open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'} transition-colors`}>
                          <i className={open ? 'ri-subtract-line' : 'ri-add-line'}></i>
                        </span>
                      </button>
                    </dt>
                    {open && (
                      <dd className="mt-3 pr-10 text-sm text-foreground-600 leading-relaxed animate-float-up">{faq.a}</dd>
                    )}
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}